module.exports = __webpack_public_path__ + "static/media/up-5door.aa05feed.png";